import { render, staticRenderFns } from "./AmDataTableMenu.vue?vue&type=template&id=5c81b5f4&scoped=true&"
import script from "./AmDataTableMenu.vue?vue&type=script&lang=js&"
export * from "./AmDataTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c81b5f4",
  null
  
)

export default component.exports